import React from 'react';

import { clearHtmlTags } from '@/helpers/HtmlHelper/clearHtmlTags';
import { getValue } from '@/helpers/GetValueHelper';

import { ICardProps } from './interface';

export const Card = React.memo(({ data, onClick }: ICardProps) => {
  const { id, title, image } = data;
  const link = getValue(data, 'cta[0].link');

  return (
    <a
      href={link}
      title={clearHtmlTags(title)}
      className="vitrine-template3__card"
      key={id}
      data-id={id}
      onClick={e => onClick(e, id)}
      data-testid={id}
    >
      <img
        className="vitrine-template3__card-image"
        src={image[0].image.url}
        alt={clearHtmlTags(title)}
      />
    </a>
  );
});
